import * as LDClient from 'launchdarkly-js-client-sdk'
import store from '@/store'

let client

export const createContextKeyAndSave = () => {
  const UUID = crypto.randomUUID()
  window.localStorage.setItem('launchDarklyKey', UUID)
  return UUID
}

export const getContextKeyFromLocalStorage = () => {
  return window.localStorage.getItem('launchDarklyKey')
}

export const updateContextKeyAndSave = newKey => {
  window.localStorage.setItem('launchDarklyKey', newKey)
}

export const getDarklyClient = () => {
  return client
}

export const createDarklyClient = async () => {
  try {
    const isAuthenticated = store.getters['auth/isAuthenticated']
    const currentKey = getContextKeyFromLocalStorage()
    const deviceKey = currentKey || createContextKeyAndSave()

    const context = {
      kind: 'multi',
      device: {
        kind: 'device',
        key: deviceKey,
        anonymous: true,
      },
    }

    if (isAuthenticated) {
      const { user_id, email, first_name, last_name } = store.getters['auth/userProfile']
      const accountData = store.getters['business/getBusinessUser']
      if (user_id) {
        context.user = {
          kind: 'user',
          key: user_id,
          email,
          name: first_name ? `${first_name} ${last_name}` : null,
          anonymous: false,
        }
      }
      if (accountData && accountData.account && accountData.account.name) {
        context['business-account'] = {
          key: accountData.account.id,
          license: accountData.account.license_type,
          name: accountData.account.name ? accountData.account.name : null,
        }
      }
    }

    if (client) {
      await client.identify(context)
    } else {
      client = LDClient.initialize(process.env.VUE_APP_DARKLY_CLIENT_SIDE_KEY, context)
    }
    await client.waitForInitialization()
    return client
  } catch (err) {
    throw err
  }
}

export const getAllDarklyFlags = () => {
  return client.allFlags()
}

export const onDarklyReady = callback => {
  return client.on('ready', callback)
}

export const onDarklyFeatureFlagChange = (featureFlag, callback) => {
  return client.on(`change:${featureFlag}`, callback)
}

export const getDarklyFlagKeyValue = async flagKey => {
  if (!client.variation) {
    await client.waitForInitialization()
  }
  const result = client.variation(flagKey)
  return result
}

export const closeDarklyClient = async callback => {
  if (!client) return
  const result = await client.close(callback)
  return result
}

export const switchDarklyContextToAnonymous = async () => {
  const currentKey = getContextKeyFromLocalStorage()
  const deviceKey = currentKey || createContextKeyAndSave()
  const context = {
    kind: 'multi',
    device: {
      kind: 'device',
      key: deviceKey,
    },
  }
  await client.identify(context)
}
